module.exports = __webpack_public_path__ + "static/media/Spectral.c0be65a8.png";